import styled from 'styled-components';

import { device } from 'config/device';

const PreviewContainer = styled.div`
  .inputContainer,
  .inputDateContainer {
    svg {
      display: none;
    }
    a input {
      color: ${(props) => props.theme.text} !important;
    }
  }

  button {
    display: none;
  }

  input,
  textarea {
    border: none;
    box-shadow: none;
    background: none;
    padding-left: 0;
  }

  input {
    font-size: 16px;
  }

  .inputLabel {
    font-weight: normal;
    color: ${(props) => props.theme.gray};
  }

  .fileUploadContainer {
    margin: 0;
  }
  .fileWrapper {
    align-items: flex-start;
    border: none;
    box-shadow: none;
    background: none;

    button {
      display: none;
    }
  }

  .signatureWrapper {
    margin: 0 !important;

    canvas {
      height: 218px !important;
      pointer-events: none;
      background-color: #fafafa;
    }
  }

  .detailTableWrapper {
    border: 1px solid #d4d4d4;

    .container {
      max-height: 30rem;
    }
  }
`;

export { PreviewContainer };
